import Client from "./_client";

export const getMeetingSessions = async (filters = {}) => {
  let url = "/meetingSession?";

  Object.keys(filters).forEach((key) => {
    if (filters[key]) url += `${key}=${filters[key]}&`;
  });

  const result = await new Client({
    path: url,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get meeting sessions. Please try again."
    );
  }

  return result?.data;
};


export const getMeetingSummary = async (id) => {
  if (!id) return {};

  const result = await new Client({
    path: `/meetingSession/${id}/summary`,
  }).get();

  if (!(result.ok || result.code === 200)) {
    throw new Error(
      result.message || "Uh Oh! Unable to get meeting summary. Please try again."
    );
  }

  return result?.data;
};